import React, { memo, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import ProjectCard from '@features/project-management-tools/components/ProjectCard';

// Sortable ProjectCard component
const SortableProjectCard = memo(({ id, projectInfo, isDetailsPage = false, onTrackMixPanelEvent }) => {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
		id
	});

	// Prevent unnecessary re-renders
	const style = useMemo(
		() => ({
			transform: CSS.Transform.toString(transform),
			transition,
			opacity: isDragging ? (isDetailsPage ? 0 : 0.5) : 1
		}),
		[transform, transition, isDragging, isDetailsPage]
	);

	return (
		<div ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<ProjectCard
				projectInfo={projectInfo}
				isDragging={isDragging}
				isDetailsPage={isDetailsPage}
				onTrackMixPanelEvent={onTrackMixPanelEvent}
			/>
		</div>
	);
});

export default SortableProjectCard;
